import { FieldProps } from "rc-field-form/es/Field";
import React, { useState } from "react";
import { Meta } from "rc-field-form/es/interface";
import Form from "rc-field-form";
import style from "./index.module.scss";
import classNames from "classnames";

interface FieldWithErrorProps extends FieldProps {
    errorClassName?: string;
}

export default function FieldWithError({
    errorClassName,
    ...props
}: FieldWithErrorProps) {
    const [meta, setMeta] = useState<Meta>();

    return (
        <React.Fragment>
            <Form.Field {...props} onMetaChange={setMeta}>
                {props.children}
            </Form.Field>

            <div className={classNames(style.error, errorClassName)}>
                {meta?.errors[0]}
            </div>
        </React.Fragment>
    );
}
